/* ============================================================
   BUILD YOUR PERFECT PIZZA — CONFIGURATION FILE
   Edit everything here. You never need to touch the core widget
   code (perfect-pizza-builder.js) to change text, colors, rules,
   recipes, links, email settings, or the ebook promo.
   ============================================================ */

window.PPB_CONFIG = {

  /* ---------- BRANDING & TEXT ---------- */
  branding: {
    title: "Build Your Perfect Pizza",
    subtitle: "Answer a few quick questions and get a pizza recipe matched to your kitchen, schedule, and taste.",
    startButton: "Start Building",
    continueButton: "Continue",
    backButton: "Previous",
    restartButton: "Restart",
    resultHeading: "Your Perfect Pizza",
    colors: {
      primary:  "#C8402F",   /* tomato red   */
      cream:    "#FBF6EC",   /* warm cream   */
      charcoal: "#2E2A26",   /* charcoal     */
      basil:    "#4A7C43",   /* basil green  */
      beige:    "#EFE6D4"    /* light beige  */
    },
    fontFamily: "'Georgia', 'Times New Roman', serif",   /* headings */
    bodyFont: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
    borderRadius: "14px"
  },

  /* ---------- RESULT PAGE LINKS ---------- */
  links: {
    relatedRecipeUrl: "https://example.com/pizza-recipes",   /* View Related Recipe button */
    relatedRecipeLabel: "View Related Recipe"
  },

  /* ---------- EMAIL COLLECTION (optional gate) ---------- */
  email: {
    enabled: false,                       /* true = show email gate before results */
    skippable: true,                      /* true = show a "No thanks, show my recipe" link */
    heading: "Send My Pizza Recipe",
    subtext: "Get your personalized recipe delivered to your inbox so you can cook it anytime.",
    button: "Send My Recipe",
    provider: "webhook",                  /* "mailchimp" | "convertkit" | "mailerlite" | "brevo" | "webhook" */
    /* Fill in only the block for the provider you use: */
    mailchimp:  { actionUrl: "" },        /* Mailchimp embedded-form POST URL */
    convertkit: { formId: "", apiKey: "" },
    mailerlite: { groupId: "", apiKey: "" },
    brevo:      { listId: "", apiKey: "" },
    webhook:    { url: "" }               /* any endpoint that accepts JSON {name, email, pizza} */
  },

  /* ---------- EBOOK / PRODUCT PROMOTION ---------- */
  promo: {
    enabled: true,
    headline: "Want More Pizza Recipes Like This?",
    text: "Get the complete pizza dough, sauce, and topping collection in the premium recipe book.",
    button: "Get the Pizza Recipe Book",
    price: "$17",
    imageUrl: "",                          /* optional ebook cover image URL */
    url: "https://example.com/pizza-ebook" /* sales page / Etsy listing / affiliate link */
  },

  /* ---------- QUIZ QUESTIONS ----------
     You can reword labels freely. Keep the "id" values unchanged —
     the recommendation rules below match on ids. */
  questions: [
    {
      key: "oven", step: 1, multi: false,
      question: "What will you use to bake your pizza?",
      options: [
        { id: "electric",   label: "Standard electric oven", icon: "oven" },
        { id: "gas",        label: "Gas oven",               icon: "flame" },
        { id: "convection", label: "Convection oven",        icon: "fan" },
        { id: "countertop", label: "Countertop pizza oven",  icon: "mini" },
        { id: "outdoor",    label: "Outdoor pizza oven",     icon: "dome" },
        { id: "grill",      label: "Grill",                  icon: "grill" },
        { id: "skillet",    label: "Cast-iron skillet",      icon: "pan" }
      ]
    },
    {
      key: "time", step: 2, multi: false,
      question: "How much time do you have?",
      options: [
        { id: "under1",    label: "Less than 1 hour", icon: "boltclock" },
        { id: "sameday",   label: "Same day",         icon: "sun" },
        { id: "overnight", label: "Overnight",        icon: "moon" },
        { id: "h24",       label: "24 hours",         icon: "clock24" },
        { id: "h48",       label: "48 hours",         icon: "clock48" },
        { id: "h72",       label: "72 hours",         icon: "clock72" }
      ]
    },
    {
      key: "crust", step: 3, multi: false,
      question: "What kind of crust do you love?",
      options: [
        { id: "thin",   label: "Thin and crispy",         icon: "crust-thin" },
        { id: "chewy",  label: "Soft and chewy",          icon: "crust-chewy" },
        { id: "airy",   label: "Light and airy",          icon: "crust-airy" },
        { id: "thick",  label: "Thick and fluffy",        icon: "crust-thick" },
        { id: "pan",    label: "Crispy-edged pan pizza",  icon: "crust-pan" },
        { id: "deep",   label: "Deep-dish style",         icon: "crust-deep" }
      ]
    },
    {
      key: "skill", step: 4, multi: false,
      question: "How experienced are you with pizza dough?",
      options: [
        { id: "first",        label: "First-time pizza maker", icon: "seed" },
        { id: "beginner",     label: "Beginner",               icon: "sprout" },
        { id: "intermediate", label: "Intermediate",           icon: "plant" },
        { id: "experienced",  label: "Experienced",            icon: "chef" }
      ]
    },
    {
      key: "flavors", step: 5, multi: true,
      question: "Which flavors sound best?",
      hint: "Choose as many as you like.",
      options: [
        { id: "classic",   label: "Classic tomato and cheese", icon: "tomato" },
        { id: "pepperoni", label: "Pepperoni",                 icon: "pepperoni" },
        { id: "spicy",     label: "Spicy",                     icon: "chili" },
        { id: "meat",      label: "Meat lovers",               icon: "meat" },
        { id: "veg",       label: "Vegetable",                 icon: "veg" },
        { id: "white",     label: "White sauce",               icon: "white" },
        { id: "bbq",       label: "BBQ",                       icon: "bbq" },
        { id: "buffalo",   label: "Buffalo chicken",           icon: "buffalo" },
        { id: "sweet",     label: "Sweet and savory",          icon: "honey" },
        { id: "seafood",   label: "Seafood",                   icon: "shrimp" },
        { id: "dessert",   label: "Dessert pizza",             icon: "dessert" }
      ]
    },
    {
      key: "diet", step: 6, multi: true,
      question: "Do you have any dietary preferences?",
      hint: "Choose as many as apply.",
      options: [
        { id: "none",       label: "No restrictions", icon: "check" },
        { id: "vegetarian", label: "Vegetarian",      icon: "leaf" },
        { id: "vegan",      label: "Vegan",           icon: "vegan" },
        { id: "glutenfree", label: "Gluten-free",     icon: "wheat" },
        { id: "dairyfree",  label: "Dairy-free",      icon: "nodairy" },
        { id: "lowsodium",  label: "Lower sodium",    icon: "salt" },
        { id: "protein",    label: "High protein",    icon: "muscle" }
      ]
    },
    {
      key: "servings", step: 7, multi: false,
      question: "How many people are you feeding?",
      options: [
        { id: "s2",    label: "1–2 people", icon: "p1" },
        { id: "s4",    label: "3–4 people", icon: "p2" },
        { id: "s6",    label: "5–6 people", icon: "p3" },
        { id: "s8",    label: "7–8 people", icon: "p4" },
        { id: "party", label: "A party",    icon: "party" }
      ]
    }
  ],

  /* ---------- SERVING SCALE ----------
     pizzas = number of dough balls / pans; factor multiplies base
     ingredient quantities (base = one 12" pizza / one pan). */
  servingScale: {
    s2:    { people: "1–2 people", pizzas: 1, factor: 1 },
    s4:    { people: "3–4 people", pizzas: 2, factor: 2 },
    s6:    { people: "5–6 people", pizzas: 3, factor: 3 },
    s8:    { people: "7–8 people", pizzas: 4, factor: 4 },
    party: { people: "A party (10+)", pizzas: 6, factor: 6 }
  },

  /* ---------- RECOMMENDATION RULES ----------
     Evaluated top to bottom; the FIRST rule whose conditions all
     match wins. Each condition matches answer ids ("any" = list).
     "style" must be a key in the recipes object below. */
  rules: [
    { if: { diet: "glutenfree" },                                          style: "glutenFreePan" },
    { if: { flavors: "dessert" },                                          style: "dessert" },
    { if: { time: "under1", oven: "skillet" },                             style: "castIronPan" },
    { if: { time: "under1", oven: "grill" },                               style: "grilled" },
    { if: { time: "under1" },                                              style: "quickFlatbread" },
    { if: { oven: ["outdoor", "countertop"], crust: ["airy", "chewy"],
            time: ["h24", "h48", "h72", "overnight"] },                    style: "neapolitan" },
    { if: { oven: ["outdoor", "countertop"], crust: "thin" },              style: "sameDayThin" },
    { if: { crust: "deep" },                                               style: "deepDish" },
    { if: { crust: "pan", time: ["overnight", "h24", "h48", "h72"] },      style: "detroit" },
    { if: { crust: "pan" },                                                style: "castIronPan" },
    { if: { crust: "thick", time: ["overnight", "h24", "h48", "h72"] },    style: "sicilian" },
    { if: { crust: "thick" },                                              style: "grandma" },
    { if: { oven: "grill" },                                               style: "grilled" },
    { if: { oven: "skillet" },                                             style: "castIronPan" },
    { if: { crust: "thin", time: "sameday" },                              style: "sameDayThin" },
    { if: { crust: "thin" },                                               style: "newYork" },
    { if: { crust: "airy", time: ["h24", "h48", "h72", "overnight"] },     style: "neapolitan" },
    { if: { crust: ["chewy", "airy"] },                                    style: "newYork" },
    { if: {},                                                              style: "newYork" }  /* fallback */
  ],

  /* ---------- FLAVOR PROFILES ----------
     Applied on top of the base style: first matching profile in the
     visitor's selections renames the pizza and sets toppings. */
  flavorProfiles: {
    bbq:       { name: "BBQ Chicken",   sauce: "BBQ sauce (thin layer)", cheese: "Mozzarella + smoked gouda", toppings: ["Cooked shredded chicken tossed in BBQ sauce", "Thin-sliced red onion"], finish: ["Chopped cilantro", "Drizzle of extra BBQ sauce"] },
    buffalo:   { name: "Buffalo Chicken", sauce: "Buffalo sauce blended with a little melted butter", cheese: "Mozzarella + crumbled blue cheese (optional)", toppings: ["Cooked shredded chicken tossed in buffalo sauce", "Thin celery slices (optional)"], finish: ["Ranch or blue cheese drizzle", "Sliced scallions"] },
    white:     { name: "White",         sauce: "Garlic ricotta base (ricotta, olive oil, minced garlic, salt)", cheese: "Mozzarella + parmesan", toppings: ["Thin garlic slices", "Fresh spinach or caramelized onion"], finish: ["Cracked black pepper", "Lemon zest (optional)"] },
    seafood:   { name: "Seafood",       sauce: "Light garlic-olive-oil base or a very thin tomato layer", cheese: "Light mozzarella (or none, Italian-style)", toppings: ["Shrimp (raw, they cook in the oven)", "Cherry tomatoes", "Garlic and chili flakes"], finish: ["Fresh parsley", "Lemon squeeze after baking"] },
    meat:      { name: "Meat Lovers",   sauce: "Classic tomato sauce", cheese: "Mozzarella + provolone", toppings: ["Pepperoni", "Cooked crumbled Italian sausage", "Diced ham or crispy bacon"], finish: ["Grated parmesan"] },
    spicy:     { name: "Spicy Pepperoni", sauce: "Tomato sauce with a pinch of chili flakes", cheese: "Mozzarella", toppings: ["Pepperoni (cup-and-char style if you can find it)", "Pickled or fresh jalapeño"], finish: ["Hot honey drizzle", "Extra chili flakes"] },
    pepperoni: { name: "Pepperoni",     sauce: "Classic tomato sauce", cheese: "Mozzarella", toppings: ["Pepperoni, edge to edge"], finish: ["Grated parmesan", "Dried oregano"] },
    veg:       { name: "Vegetarian Garden", sauce: "Classic tomato sauce", cheese: "Mozzarella", toppings: ["Bell pepper", "Red onion", "Mushrooms", "Cherry tomatoes", "Baby spinach (added after baking)"], finish: ["Fresh basil", "Olive oil drizzle"] },
    sweet:     { name: "Sweet & Savory", sauce: "Classic tomato sauce", cheese: "Mozzarella + a little gorgonzola", toppings: ["Prosciutto (added after baking)", "Caramelized onion or fig jam dots"], finish: ["Hot honey drizzle", "Arugula tossed in olive oil"] },
    classic:   { name: "Margherita-Style", sauce: "Classic tomato sauce", cheese: "Fresh mozzarella", toppings: ["Nothing else needed — let the crust shine"], finish: ["Fresh basil after baking", "Olive oil drizzle", "Pinch of flaky salt"] }
  },
  /* order used to pick when several flavors are selected */
  flavorPriority: ["bbq", "buffalo", "white", "seafood", "meat", "spicy", "pepperoni", "veg", "sweet", "classic"],

  /* ---------- RECIPES (base pizza styles) ----------
     hydration = % of flour weight. flourBase = grams of flour for
     ONE pizza/pan (scaled by servingScale factor). oilPct/sugarPct
     as % of flour. Images: replace imageUrl with your own photos —
     if empty, a built-in illustration is shown. */
  recipes: {
    sameDayThin: {
      name: "Same-Day Thin-Crust Pizza",
      imageUrl: "",
      description: "A crackly, cracker-adjacent crust you can mix, rest, and bake within a few hours. Rolled thin, lightly topped, baked hot.",
      difficulty: "Easy", hydration: 60, flourBase: 160, oilPct: 3, sugarPct: 1,
      flour: "All-purpose or bread flour",
      prepTime: "25 min active", fermentTime: "2–4 hours at room temperature", bakeTime: "8–10 minutes",
      surface: "Pizza steel, stone, or an upside-down baking sheet",
      shaping: "Roll with a rolling pin to about 3 mm (1/8\") — docking with a fork keeps it flat.",
      doughTemp: "Room temperature (about 72°F / 22°C) for the rise.",
      why: "It fits a same-day schedule, loves a standard home oven, and delivers the thin, crispy bite you asked for."
    },
    newYork: {
      name: "New York–Style Pizza",
      imageUrl: "",
      description: "The classic foldable slice: thin center, chewy puffed rim, baked on a steel or stone as hot as your oven goes.",
      difficulty: "Moderate", hydration: 63, flourBase: 250, oilPct: 2, sugarPct: 1.5,
      flour: "Bread flour (high protein)",
      prepTime: "30 min active", fermentTime: "Overnight to 48 hours, cold-fermented in the fridge", bakeTime: "10–14 minutes",
      surface: "Pizza steel (best) or stone, upper-middle rack",
      shaping: "Press out the center leaving a 1\" rim, then stretch over your knuckles to 12–14\".",
      doughTemp: "Cold ferment at fridge temperature; pull dough out 1–2 hours before shaping.",
      why: "Your oven, schedule, and crust preference line up exactly with the classic NY slice formula."
    },
    neapolitan: {
      name: "Neapolitan Pizza",
      imageUrl: "",
      description: "Soft, blistered, leopard-spotted crust with an airy rim — the 60–90 second bake that pizza ovens were made for.",
      difficulty: "Advanced", hydration: 65, flourBase: 250, oilPct: 0, sugarPct: 0,
      flour: "00 flour (finely milled Italian flour)",
      prepTime: "30 min active", fermentTime: "24–72 hours (cold ferment for 48h+ gives the best flavor)", bakeTime: "60–90 seconds at 850°F+ / 450°C+",
      surface: "Pizza oven floor, launched from a lightly floured peel",
      shaping: "Press from the center outward, protecting the rim. Never use a rolling pin.",
      doughTemp: "Ball the dough and proof at room temperature for 2 hours before baking.",
      why: "You have the high-heat oven and the fermentation time that true Neapolitan demands — most people don't."
    },
    detroit: {
      name: "Detroit-Style Pizza",
      imageUrl: "",
      description: "A thick, airy square baked in an oiled steel pan with cheese pushed to the edges for a caramelized, crispy frame.",
      difficulty: "Moderate", hydration: 70, flourBase: 300, oilPct: 2, sugarPct: 0,
      flour: "Bread flour",
      prepTime: "25 min active", fermentTime: "Overnight cold ferment, then 2–3 hours proofing in the pan", bakeTime: "12–15 minutes",
      surface: "Detroit steel pan or a deep 9×13\" metal pan, lower-middle rack",
      shaping: "No shaping — press the dough into the oiled pan with your fingertips and let it proof.",
      doughTemp: "Cold ferment, then room-temperature pan proof until puffy.",
      why: "Crispy-edged pan crust plus an overnight window is the textbook Detroit setup."
    },
    sicilian: {
      name: "Sicilian Pizza",
      imageUrl: "",
      description: "Thick, fluffy, focaccia-like squares with a golden fried-crisp bottom from a generously oiled sheet pan.",
      difficulty: "Moderate", hydration: 72, flourBase: 350, oilPct: 4, sugarPct: 1,
      flour: "Bread flour",
      prepTime: "25 min active", fermentTime: "Overnight cold ferment, then 2 hours proofing in the pan", bakeTime: "18–22 minutes",
      surface: "Oiled half-sheet pan or 12×18\" pan, lower-middle rack",
      shaping: "Stretch the dough toward the pan corners in two sessions, 20 minutes apart.",
      doughTemp: "Cold ferment; pan-proof at room temperature until doubled.",
      why: "Thick and fluffy with real fermentation time points straight to a Sicilian sheet pan."
    },
    grandma: {
      name: "Grandma Pizza",
      imageUrl: "",
      description: "The same-day sheet-pan classic: thinner than Sicilian, olive-oil crisped, with sauce striped over the cheese.",
      difficulty: "Easy", hydration: 68, flourBase: 300, oilPct: 4, sugarPct: 1,
      flour: "All-purpose or bread flour",
      prepTime: "20 min active", fermentTime: "2–4 hours, proofed right in the oiled pan", bakeTime: "15–18 minutes",
      surface: "Oiled half-sheet pan, lower rack",
      shaping: "Press into the oiled pan with fingertips — dimple it like focaccia.",
      doughTemp: "Room temperature the whole way.",
      why: "You get a thick, satisfying pan pizza on a same-day timeline with almost no shaping skill required."
    },
    castIronPan: {
      name: "Cast-Iron Pan Pizza",
      imageUrl: "",
      description: "Deep golden crust fried crisp in a hot cast-iron skillet — the most forgiving great pizza there is.",
      difficulty: "Easy", hydration: 70, flourBase: 250, oilPct: 3, sugarPct: 1,
      flour: "All-purpose flour",
      prepTime: "15 min active", fermentTime: "1–2 hours (or overnight for better flavor)", bakeTime: "15–18 minutes, finished 2 min on the stovetop for a crisp bottom",
      surface: "10–12\" cast-iron skillet, generously oiled",
      shaping: "Press the dough into the oiled skillet — no stretching or tossing needed.",
      doughTemp: "Room temperature; a no-knead overnight version works beautifully.",
      why: "Cast iron plus a tight schedule is exactly what pan pizza was invented for."
    },
    deepDish: {
      name: "Chicago-Inspired Deep Dish",
      imageUrl: "",
      description: "A buttery, biscuit-like crust pressed up the sides of a deep pan, layered cheese-first, sauce on top.",
      difficulty: "Moderate", hydration: 55, flourBase: 350, oilPct: 8, sugarPct: 1,
      flour: "All-purpose flour + 2 tbsp cornmeal per pizza",
      prepTime: "30 min active", fermentTime: "1.5–2 hours at room temperature", bakeTime: "25–30 minutes",
      surface: "9–10\" deep-dish or cake pan, lower rack",
      shaping: "Roll into a circle and press up the sides of the buttered pan.",
      doughTemp: "Room temperature rise; the butter/oil keeps it tender.",
      why: "Deep-dish was your call — this crust holds a full layered build without going soggy."
    },
    grilled: {
      name: "Grilled Pizza",
      imageUrl: "",
      description: "Dough goes straight on the grates: smoky char, crisp-chewy texture, toppings added after the flip.",
      difficulty: "Moderate", hydration: 62, flourBase: 200, oilPct: 4, sugarPct: 0,
      flour: "Bread flour",
      prepTime: "20 min active", fermentTime: "1–2 hours same-day (or use overnight dough)", bakeTime: "2–3 minutes per side over direct heat",
      surface: "Directly on oiled grill grates, lid closed between steps",
      shaping: "Stretch into rustic ovals — thin, and don't worry about perfect circles.",
      doughTemp: "Room temperature and slightly firm — easier to handle on the grates.",
      why: "You've got live fire — grilled pizza turns that into char and smoke no oven can copy."
    },
    quickFlatbread: {
      name: "Quick Flatbread Pizza",
      imageUrl: "",
      description: "A no-yeast (or instant-rise) flatbread base that gets you from craving to eating in under an hour.",
      difficulty: "Easy", hydration: 58, flourBase: 150, oilPct: 5, sugarPct: 0,
      flour: "All-purpose flour (plus 1 tsp baking powder per pizza if skipping yeast)",
      prepTime: "10 min active", fermentTime: "15–20 minute rest only", bakeTime: "8–10 minutes",
      surface: "Preheated baking sheet or stone, upper rack",
      shaping: "Roll thin with a rolling pin directly on parchment.",
      doughTemp: "Use warm water (100°F / 38°C) to speed everything up.",
      why: "Under an hour rules out slow fermentation — this flatbread gets real pizza on the table fast."
    },
    glutenFreePan: {
      name: "Gluten-Free Pan Pizza",
      imageUrl: "",
      description: "A crisp-bottomed pan pizza built on a 1:1 gluten-free blend — spreadable batter-style dough, no kneading.",
      difficulty: "Easy", hydration: 85, flourBase: 250, oilPct: 4, sugarPct: 2,
      flour: "1:1 gluten-free flour blend (with xanthan gum)",
      prepTime: "15 min active", fermentTime: "45–60 minute rise in the pan", bakeTime: "Par-bake 10 min, top, then 10–12 min more",
      surface: "Well-oiled 10–12\" pan or skillet, middle rack",
      shaping: "Spread with an oiled spatula — gluten-free dough is more batter than dough.",
      doughTemp: "Warm spot for the rise; gluten-free dough likes gentle warmth.",
      why: "Pan-style is the most reliable gluten-free method — crisp bottom, tender crumb, zero gluten needed."
    },
    dessert: {
      name: "Dessert Pizza",
      imageUrl: "",
      description: "A lightly sweetened crust with Nutella, fruit, or cinnamon-sugar toppings — pizza night's closing act.",
      difficulty: "Easy", hydration: 60, flourBase: 200, oilPct: 4, sugarPct: 6,
      flour: "All-purpose flour",
      prepTime: "15 min active", fermentTime: "1 hour (or use any leftover pizza dough)", bakeTime: "8–10 minutes, toppings added after baking",
      surface: "Baking sheet or stone, middle rack",
      shaping: "Roll to medium thickness — sturdy enough to carry spreads and fruit.",
      doughTemp: "Room temperature.",
      why: "You picked dessert pizza — this base bakes up golden and slightly sweet, ready for anything."
    }
  },

  /* ---------- BAKE SETTINGS BY OVEN ---------- */
  ovenSettings: {
    electric:   { temp: "500–550°F (260–290°C), as hot as it goes", preheat: "45–60 minutes with the steel or stone inside", rack: "Upper-middle rack for thin styles; lower-middle for pan styles" },
    gas:        { temp: "500–550°F (260–290°C)", preheat: "45 minutes with the steel or stone inside", rack: "Upper-middle rack; watch the bottom — gas ovens heat from below" },
    convection: { temp: "475–500°F (245–260°C) with the fan on", preheat: "30–40 minutes", rack: "Middle rack; the fan browns tops quickly, so check early" },
    countertop: { temp: "700–850°F (370–450°C) on the pizza setting", preheat: "15–20 minutes until the stone reads full temperature", rack: "Directly on the built-in stone; rotate halfway" },
    outdoor:    { temp: "800–900°F (425–480°C) floor temperature", preheat: "20–30 minutes; aim the flame low and rolling", rack: "Launch onto the oven floor; turn every 20–30 seconds" },
    grill:      { temp: "High direct heat, 500–600°F (260–315°C) at the grate", preheat: "15 minutes, lid closed, grates oiled", rack: "Directly on the grates; move to indirect heat after topping" },
    skillet:    { temp: "450°F (230°C) oven, skillet finished on medium-high stovetop", preheat: "Oven fully preheated; skillet does not need preheating for pan pizza", rack: "Lower-middle rack, then 2 minutes on the stovetop to crisp the bottom" }
  },

  /* ---------- SAUCE / CHEESE BASES & DIETARY SWAPS ---------- */
  components: {
    sauceClassic: "Classic tomato sauce: one 28-oz can of crushed San Marzano-style tomatoes, 1 tsp salt, 1 tbsp olive oil, a pinch of oregano. No cooking needed.",
    dietary: {
      vegan:      { cheese: "Plant-based mozzarella shreds (or skip cheese and finish with cashew cream)", note: "All meat toppings replaced with roasted vegetables, marinated mushrooms, or plant-based sausage.", removeMeat: true, removeDairy: true, removeSeafood: true },
      vegetarian: { note: "Meat toppings swapped for roasted mushrooms, peppers, or plant-based pepperoni.", removeMeat: true, removeSeafood: true },
      dairyfree:  { cheese: "Dairy-free mozzarella shreds, or go cheese-free marinara-style with extra olive oil and herbs", removeDairy: true },
      lowsodium:  { note: "Salt reduced by one-third in the dough, no-salt-added tomatoes for the sauce, low-sodium cheese, and cured meats kept light.", saltFactor: 0.66 },
      protein:    { note: "Boosted with grilled chicken breast, part-skim mozzarella, and a Greek-yogurt-enriched dough option (swap 20% of the water for Greek yogurt)." }
    }
  }
};
